import { useEffect, useState } from "react"
import { toast } from "@/hooks/use-toast"

export function usePersonAdd(personId: number) {
  const [currentStep, setCurrentStepState] = useState(1)
  const [completedSteps, setCompletedSteps] = useState<number[]>([])

  useEffect(() => {
    const key = `cineblocks:person:${personId}:steps`
    const saved = localStorage.getItem(key)

    if (saved) {
      try {
        setCompletedSteps(JSON.parse(saved))
      } catch {
        localStorage.removeItem(key)
      }
    }
  }, [personId])

  const canNavigateToStep = (targetStep: number): boolean => {
    return targetStep === 1 || completedSteps.includes(targetStep - 1)
  }

  const getStepStatus = (
    step: number
  ): "complete" | "current" | "incomplete" | "locked" => {
    if (step === currentStep) return "current"
    if (completedSteps.includes(step)) return "complete"
    if (!canNavigateToStep(step)) return "locked"
    return "incomplete"
  }

  const markStepComplete = (step: number) => {
    setCompletedSteps((prev) => {
      const updated = [...new Set([...prev, step])]
      localStorage.setItem(
        `cineblocks:person:${personId}:steps`,
        JSON.stringify(updated)
      )
      return updated
    })
  }

  const setCurrentStep = (step: number) => {
    setCurrentStepState(step)
  }

  const navigateToStep = (step: number) => {
    if (canNavigateToStep(step)) {
      setCurrentStepState(step)
      return
    }

    toast({
      title: "Acesso bloqueado",
      description: `Complete o Step ${step - 1} antes de continuar`,
      variant: "destructive",
    })
  }

  return {
    currentStep,
    setCurrentStep,
    navigateToStep,
    completedSteps,
    markStepComplete,
    canNavigateToStep,
    getStepStatus,
  }
}
